/**
 * @enum {string}
 */
export default {
  /**
   * @type {string}
   */
  AND: '&&',
  /**
   * @type {string}
   */
  NOT: '!',
  /**
   * @type {string}
   */
  OR: '||'
};
